import { RecipeSearch } from "../../components/recipe-search/recipe-search";

export const RecipePage = () => {
  return <RecipeSearch />;
};
